import React, { useState } from "react";
import { Boxed } from "../../components/Boxed.components";
import { Text } from "../../components/Text.components";
import  RequestBreakdown  from './RequestBreakdown/index';
// import ActivityBreakdown from "./ActivityBreakdown/index";


export const Reports = () => {
  // const [showReport, setShowReport] = useState(true);
  return (
    <>
     <RequestBreakdown/>
    </>
  );
};

/* {showReport ? <ReportBreakdown /> : <ActivityBreakdown />} */
/* <Boxed
        display="flex"
        margin="30px auto"
        justifyContent="space-between"
        width="50%"
      >
        <Boxed
          width="250px"
          border={showReport ? "2px solid #0F3BAB" : "1px solid #ccc"}
          height="100px"
          textAlign="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          borderRadius="5px"
          onClick={() => setShowReport(true)}
          cursor="pointer"
        >
          <Text fontSize="20px">Request Breakdown</Text>
        </Boxed>
        <Boxed
          width="250px"
          border={!showReport ? "2px solid #0F3BAB" : "1px solid #ccc"}
          height="100px"
          textAlign="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          borderRadius="5px"
          onClick={() => setShowReport(false)}
          cursor="pointer"
        >
          <Text fontSize="20px">Activity Breakdown</Text>
        </Boxed>
      </Boxed> */